import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  getAll: function () {
    return axios.get(`${window.apiURL}api/forms`)
  },
  get: function (id) {
    return axios.get(`${window.apiURL}api/forms/${id}`)
  },
  submit: function (formId, fields) {
    return axios.post(`${window.apiURL}api/forms/${formId}/submit`, fields)
  }
}



// WEBPACK FOOTER //
// ./src/services/form.js